import React, {useEffect} from 'react';
import {useCollection} from "../../cms/factory";
import styled from "styled-components";
import NewsCard from "./NewsCard";
import {AsyncReveal} from "../AsyncReveal";
import ContentLayout from "../ContentLayout";

interface NewsData {
    id: string;
    title: string;
    shortDescription: string;
    slug?: string;
    publishedAt?: string | null;
    logo1?: { url?: string | null } | null;
    logo2?: { url?: string | null } | null;
}

const SELECTION = `
    id
    title
    shortDescription
    slug
    publishedAt
    logo1 { url }
    logo2 { url }
`;

const ARGS = `
    where: { 
        status: { 
            equals: published 
        } 
    }, 
    orderBy: { 
        publishedAt: desc 
    }, 
`

const News = () => {
    const {data: news, loading, error} = useCollection<NewsData>(
        "newsItem",
        SELECTION,
        ARGS
    );

    useEffect(() => {
        window.scrollTo({ top: 0 });
    }, []);

    return (
        <ContentLayout backTo="/" title="News" loading={loading}>
            <AsyncReveal loading={loading} error={error} loaderDelay={0.5}>
                <Section>
                    {news?.map(({id, title, shortDescription, slug, publishedAt, logo1, logo2}) => {
                        const hasLogos = logo1?.url || logo2?.url;
                        const showHeader = Boolean(publishedAt) || hasLogos;

                        return (
                            <NewsCard key={id}>
                                {showHeader && (
                                    <NewsCard.Header>
                                        {publishedAt && <NewsCard.Date ISO={publishedAt}/>}
                                        {hasLogos && (
                                            <NewsCard.Logos>
                                                {logo1?.url && <NewsCard.Logo src={logo1.url} alt="Logo 1"/>}
                                                {logo2?.url && <NewsCard.Logo src={logo2.url} alt="Logo 2"/>}
                                            </NewsCard.Logos>
                                        )}
                                    </NewsCard.Header>
                                )}
                                <NewsCard.Title as="h2">{title}</NewsCard.Title>
                                <NewsCard.Description>{shortDescription}</NewsCard.Description>
                                {slug && <NewsCard.Link to={`/news/${slug}`}>Read more</NewsCard.Link>}
                            </NewsCard>
                        );
                    })}
                </Section>
            </AsyncReveal>
        </ContentLayout>
    );
}

export default News;

const Section = styled.section`
    display: flex;
    flex-direction: column;
    gap: 24px;
    overflow: hidden;
`
